import Vue from 'vue'
import Router from 'vue-router'
import screenfull from 'screenfull'

import store from './store'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  screenfull.exit();

  store.dispatch('stopScrolling', false)
  store.dispatch('turnMobileMenu', false)
  store.dispatch('turnFilterUI', false)
  next()
})

export default router
